import http from '@/plugins/axios/axios';

export default class EmpresaService {

    salvar(requisicao) {       
        return http.post('/api/empresa/salvar-cnpj', requisicao);
    }

    alterarPeriodoFechamento(requisicao) {       
        return http.post('/api/empresa/alterar-periodo-fechamento', requisicao);
    }

    buscarCnpj(requisicao) {       
        return http.post('/api/empresa/buscar-cnpj', requisicao);
    }

    buscarEmpresaPrincipal(requisicao) {       
        return http.post('/api/empresa/buscar', requisicao);
    }
    
    listar(requisicao) {       
        return http.post('/api/empresa/listar', requisicao);
    }
    
    listarCNPJs(requisicao) {       
        return http.post('/api/empresa/listar-cnpjs', requisicao);
    }

    listarEstados() {        
        return http.get('/api/empresa/listar-estados');
    }

    listarCidades(idEstado) {       
        return http.get('/api/empresa/listar-cidades/'+idEstado);
    }
}